// extracted by mini-css-extract-plugin
export default {"versionCardBody":"versionCardBody---nmxmG","changedRecordsList":"changedRecordsList---M3jWk","changedRecord":"changedRecord---Xgk60"};